import React, { useMemo } from 'react';
import { css } from 'linaria';
import { Layout } from 'fronton-react';
import { RemoteCarouselWithBasket, RootLayout } from 'common/components';
import { Breadcrumb, MODEL_JSON_STORE_NAME, selectBreadcrumbs } from 'modules/model-json';
import { State } from 'store/types';
import { useStoreon } from 'storeon/react';
import { AccessoriesSection, HeaderSection, RacksSection, SolutionSection } from './components';
import {
  PRODUCT_ID_LIST,
  SOLUTION_LIST,
  SPACEO_KUB_PATH,
  UPDATED_SPACEO_BREADCRUMB,
} from './spaceo-kub-constants';

const spaceoCarousel = css`
  padding-bottom: 10px;
  margin-bottom: 0;

  @media (--only-mobile) {
    padding-top: 60px;
  }

  @media (--from-tablet) {
    padding-top: 70px;
  }
`;

/**
 * Вью лендинга Спасео Куб
 */
export const SpaceoKub = () => {
  const { modelJson } = useStoreon<State>(MODEL_JSON_STORE_NAME);
  const breadcrumbs = useMemo(() => selectBreadcrumbs(modelJson), [modelJson]);
  const modifiedBreadcrumbs = useMemo(
    () =>
      breadcrumbs?.map((breadcrumb: Breadcrumb, index: number) => {
        if (index === 1) {
          return UPDATED_SPACEO_BREADCRUMB;
        }

        return breadcrumb;
      }),
    [breadcrumbs]
  );

  return (
    <RootLayout customBreadcrumbs={modifiedBreadcrumbs} currentPage={SPACEO_KUB_PATH}>
      <Layout>
        <HeaderSection />

        {SOLUTION_LIST.map(solution => (
          <SolutionSection key={solution.sectionName} {...solution} />
        ))}

        <RacksSection />
        <AccessoriesSection />
      </Layout>

      <RemoteCarouselWithBasket
        className={spaceoCarousel}
        elementBlock="landingSpaceoKub / Популярные товары"
        productIdList={PRODUCT_ID_LIST}
        title="Популярные товары"
      />
    </RootLayout>
  );
};
